import {lazy} from 'react';
import AccessProtected from 'lib/RouteProtection';

const HRList = lazy(() => import('./HRList'));
const HRDetails = lazy(() => import('./HRDetails'));
const HRDashboard = lazy(() => import('./Dashboard'));
const MyLeaves = lazy(() => import('./MyLeaves'));
const LeaveApproval = lazy(() => import('./LeaveApproval'));
const LeaveRequest = lazy(() => import('./LeaveRequest'));

export const hrManagerConfig = [
  {
    path: '/hr-manager/my-leaves',
    element: (
      <AccessProtected>
        <MyLeaves />
      </AccessProtected>
    ),
  },
  {
    path: '/hr-manager/hr-dashboard',
    element: (
      <AccessProtected>
        <HRDashboard />
      </AccessProtected>
    ),
  },
  {
    path: '/hr-manager/leave-approval',
    element: (
      <AccessProtected>
        <LeaveApproval />
      </AccessProtected>
    ),
  },
  {
    path: '/hr-manager/leave-request',
    element: (
      <AccessProtected>
        <LeaveRequest />
      </AccessProtected>
    ),
  },
  {
    path: '/hr-manager/hr-letter',
    element: (
      <AccessProtected>
        <HRList />
      </AccessProtected>
    ),
  },
  {
    path: '/hr-manager/hr-details/:param',
    element: <HRDetails />,
  },
];
